import React, { useMemo } from 'react'

const project = require('EurestoConfig/project.config')

export default React.memo(props => {

    const token = useMemo(() => localStorage.getItem('token'), [])

    return <iframe style={{ width: '100%', height: '100%' }}
        frameBorder={"0"}
        src={`${project.api.replace(5000, 3000).replace('api', 'cloud')}configuration/hotel?navigation=off&token=${token}#Tarif`} sandbox />
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Hotel/Tarif/index.js